import { Browser } from '@capacitor/browser';
import { Globals } from '@/modules/Globals';

/**
 * Opens `url` outside the admin: the in-app browser in the Capacitor APK
 * (`window.open` does nothing there), a new tab on the web. A `mailto:` link
 * goes to the mail app through the location instead: a new tab would stay
 * empty on the web, and the APK's WebView hands the scheme to the system.
 */
export async function openExternal(url: string): Promise<void> {
  if (url.startsWith('mailto:')) window.location.href = url;
  else if (Globals.isCapacitor) await Browser.open({ url });
  else window.open(url, '_blank', 'noopener');
}
